import Vue from 'vue'
import VueRouter from 'vue-router'
import {
	getToken
} from '@/utils/auth'
import {
	Message
} from 'element-ui'

Vue.use(VueRouter)

const routes = [{
		path: '/',
		name: 'Home',
		component: () => import('@/views/Home.vue')
	},
	{
		path: '/login',
		name: 'Login',
		component: () => import('@/views/User/Login.vue'),
		meta: {
			hidden: true
		}
	},
	{
		path: '/register',
		name: 'Register',
		component: () => import('@/views/User/Register.vue'),
		meta: {
			hidden: true
		}
	},
	{
		path: '/category',
		name: 'Category',
		component: () => import('@/views/Category.vue')
	},
	{
		path: '/InfoDetail',
		name: 'InfoDetail',
		component: () => import('@/views/InfoDetail.vue')
	},
	{
		path: '/publish',
		name: 'Publish',
		component: () => import('@/views/Publish.vue'),
		meta: {
			requireAuth: true
		}
	},
	{
		path: '/user/center',
		name: 'UserCenter',
		component: () => import('@/views/User/Center.vue'),
		meta: {
			requireAuth: true
		}
	},
	{
		path: '*',
		name: 'NotFound',
		component: () => import('@/views/NotFound.vue'),
		meta: {
			hidden: true
		}
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior() {
		return {
			x: 0,
			y: 0
		}
	}
})



// 路由守卫
router.beforeEach((to, from, next) => {
	if (to.meta.requireAuth) {
		const token = getToken()
		if (token) {
			next()
		} else {
			Message.warning('请先登录！')
			next({
				path: '/login',
				query: {
					redirect: to.fullPath
				}
			})
		}
	} else {
		next()
	}
})

export default router